export interface LawsuitWizardParams {
  step?: string;
  lawsuitId?: string;
}

/**
 * Parse URL parameters for lawsuit wizard navigation
 */
export const parseLawsuitWizardParams = (searchParams: URLSearchParams): LawsuitWizardParams => {
  return {
    step: searchParams.get('step') || undefined,
    lawsuitId: searchParams.get('lawsuitId') || undefined,
  };
};

/**
 * Build URL parameters for lawsuit wizard navigation
 */
export const buildLawsuitWizardParams = (params: LawsuitWizardParams): URLSearchParams => {
  const searchParams = new URLSearchParams();
  
  if (params.step) {
    searchParams.set('step', params.step);
  }
  
  if (params.lawsuitId) {
    searchParams.set('lawsuitId', params.lawsuitId);
  }
  
  return searchParams;
};

/**
 * Update URL with lawsuit wizard parameters without navigation
 */
export const updateLawsuitWizardURL = (params: LawsuitWizardParams) => {
  const searchParams = buildLawsuitWizardParams(params);
  const newURL = `${window.location.pathname}?${searchParams.toString()}`;
  window.history.replaceState({}, '', newURL);
};

/**
 * Navigate to lawsuit wizard with specific parameters
 */
export const navigateToLawsuitWizard = (params: LawsuitWizardParams) => {
  const searchParams = buildLawsuitWizardParams(params);
  const url = `/file-lawsuit?${searchParams.toString()}`;
  window.location.href = url;
};